import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Router from 'router'
import 'styles/global.css'
import { ScrollToTop } from 'components/scrollToTop'
//Boostrapp
import { AuthWatcher } from 'components/authWatcher'
import { AuthProvider } from 'auth/context/AuthProvider'

function App () {
  return (
    <BrowserRouter>
     
      <ScrollToTop />
      <AuthProvider> 
         <AuthWatcher>
        <Router />
        </AuthWatcher>
        </AuthProvider>
      

    </BrowserRouter>
   
  )
}

export default App
